import React, { useState } from 'react';
import nukeIcon from './assets/nuclear.png';
import { Box, Typography, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';

const LimitedNukeButton = () => {
  const [hovered, setHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

  const nukeButton = {
    backgroundColor: '#49a7ab',
    borderRadius: '48px',
    color: 'white',
    border: 'none',
    float: 'right',
    padding: '6px 12px 6px 4px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '14px',
    position: 'absolute',
    top: '4px',
    right: '6px',
    userSelect: 'none',
    zIndex: 9999,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: 'width 0.3s ease',
    width: hovered ? '242px' : '32px',
    height: hovered ? 'auto' : '32px',
  };

  const iconStyle = {
    height: '24px',
    width: '24px',
    objectFit: 'contain',
    flexShrink: 0,
  };

  const textStyle = {
    marginLeft: '8px',
    opacity: hovered ? 1 : 0,
    transition: 'opacity 0.2s ease',
  };

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setModalPosition({ x: rect.left - 10, y: rect.top + rect.height });
    setShowModal(true);
    setTimeout(() => setShowModal(false), 4000); // stay 1s longer
  };

  return (
    <>
      <button
        style={nukeButton}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={handleClick}
        type="button"
        title={
          'Resets all MATCHES back to their system detected values. This includes line items and zone designations.'
        }
      >
        <img src={nukeIcon} alt="Nuke Button" style={iconStyle} />
        <span style={textStyle}>RESET ENTIRE PROJECT</span>
      </button>

      {showModal && (
        <Box
          sx={{
            position: 'fixed',
            top: '39%',
            left: '69%',
            transform: 'translate(-100%, -50%) scale(1)',
            bgcolor: '#fff',
            color: '#49a7ab',
            borderRadius: 2,
            boxShadow: 5,
            p: 1.5,
            zIndex: 9999,
            textAlign: 'center',
            minWidth: 500,
            whiteSpace: 'nowrap',
            animation: 'popout 0.2s ease',
          }}
        >
          <Typography
            variant="body1"
            sx={{ mb: 1, whiteSpace: 'nowrap', fontWeight: 500,  }}
          >
            Premium Functionality
          </Typography>
          <NavLink to="/accounts" style={{ textDecoration: 'none' }}>
            <Button
              variant="contained"
              sx={{
                bgcolor: '#49a7ab',
                color: '#fff',
                fontWeight: 600,
                fontSize: '.875rem',
                '&:hover': { bgcolor: '#42999d' },
              }}
            >
              Subscribe
            </Button>
          </NavLink>
          <style>
            {`
              @keyframes popout {
                0% { transform: translate(-100%, -50%) scale(0.7); opacity: 0; }
                100% { transform: translate(-100%, -50%) scale(1); opacity: 1; }
              }
            `}
          </style>
        </Box>
      )}
    </>
  );
};

export default LimitedNukeButton;
